import FilterType from './filterType';
import valueIn from '../../utils/valueIn';

export default FilterType({
    id: 'DISTANCE',
    filterFunction: (allHotelIds, filterTree, currentFilterValues, segmentationState, filterId, hotels, steps) => {
    // Block EVERYTHING not in range
    // Match EVERYTHING in range
    // Potentials = EVERYTHING that is not BLOCKED

        const isHotelInDistanceRange = {};
        let isFilterActive = false;

        const distanceIds = {
            BEACH_DISTANCE: 'distanceToNearestBeach',
            CENTER_DISTANCE: 'distanceToNearestCenter',
            METRO_DISTANCE: 'distanceToMetro'
        };

        const selectedDistance = valueIn(currentFilterValues, 'selectedDistance.value');
        const maximumDistance = (steps && steps.length && steps[steps.length - 1]) || valueIn(currentFilterValues, 'maximumDistance');

        if (selectedDistance === 0 || (selectedDistance && selectedDistance < maximumDistance)) {
            isFilterActive = true;

            const bucket = valueIn(filterTree, [filterId, 'hasDistance']) || [];

            bucket.forEach(hotelId => {
                const hotelData = valueIn(hotels, [`${hotelId}`]);
                const distanceFacts = valueIn(hotelData, 'distanceFacts');
                const distanceFact = distanceFacts.find(fact => valueIn(fact, 'id') === distanceIds[filterId]);
                const distance = valueIn(distanceFact, 'distance');

                isHotelInDistanceRange[hotelId] = distance >= 0 && distance <= selectedDistance;
            });
        }

        if (!isFilterActive) {
            return 0;
        }

        const distancePotentials = [];

    // NB: We _HAVE_ to go through all hotelIds (not just those that are not blocked) because
    //     a filter can have potentials that are blocked externally but we still may need to block
    //     them from this filter (Filter A blocks hotel X -- but it is in A:s potentials); if this
    //     filter also blocks X, we must remove it from A:s potentials!
        allHotelIds.forEach(hotelId => {
            if (!segmentationState.block[hotelId]) {
        // Everything that is not blocked will be a potential (even if we block it externally)
                distancePotentials.push(hotelId);
            }

            const hotelData = valueIn(hotels, [`${hotelId}`]);
            const distanceFacts = valueIn(hotelData, 'distanceFacts');
            const distanceFact = distanceFacts && distanceFacts.find && distanceFacts.find(fact => valueIn(fact, 'id') === distanceIds[filterId]);
            let distance = valueIn(distanceFact, 'distance') || 0;

            const isInRange = distance >= 0 && distance <= selectedDistance;
            if (isInRange) {
                segmentationState.match[hotelId] = !segmentationState.block[hotelId];
            } else {
                segmentationState.match[hotelId] = false;
                segmentationState.block[hotelId] = true;

                Object.keys(segmentationState.potentials).forEach(filterId => {
                    if (segmentationState.potentials[filterId][hotelId]) {
                        segmentationState.potentials[filterId][hotelId] = false;
                    }
                });
            }
        });

        segmentationState.potentials[filterId] = {};
        distancePotentials.forEach(hotelId => {
            segmentationState.potentials[filterId][hotelId] = true;
        });

        return 1;
    }
});
